/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { Container, Row, Col } from 'react-grid-system'

import H1 from '../typography/H1'
import IconLightbulp from '../svg/IconLightbulp'
import IconList from '../svg/IconList'
import IconSpeech from '../svg/IconSpeech'
import theme from '../../theme'
import { SectionColumn } from './AboutUsSection3'

const AboutUsSection6: React.FC = () => {
  const title1 = 'Tell Us More About Your Project'
  const title2 = 'Receive Artwork Suggestions'
  const title3 = 'Provide Feedback on Artwork Proposals'
  return (
    <div
      css={{
        backgroundColor: theme.colors.grayBg1,
        padding: '2em 0px',
        textAlign: 'center',
      }}
    >
      <Container>
        <Row>
          <Col>
            <H1>The Sourcing Process</H1>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <SectionColumn title={title1} Icon={IconList}>
              Upload relevant floorplans, elevations and/or renders for our
              consultants to review.{' '}
            </SectionColumn>
          </Col>
          <Col xs={12} md={4}>
            <SectionColumn title={title2} Icon={IconLightbulp} addBr={true}>
              Our consultants will propose artwork options based on your project
              needs and preferences.{' '}
            </SectionColumn>
          </Col>
          <Col xs={12} md={4}>
            <SectionColumn title={title3} Icon={IconSpeech}>
              Review the artwork suggestions, let us know your feedback and we
              will further refine the proposal.{' '}
            </SectionColumn>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUsSection6
